import { useEffect, useRef, useState } from 'react';

import { NavLink, useLocation } from 'react-router-dom';

import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';

import { dictionary } from '../../general/links';

interface IBreadcrumb {
  to: string;
  label: string;
  withParams?: boolean;
}

const NibBreadcrumbs = () => {
  const location = useLocation();
  const unknown = { to: '/', label: 'Unknown page go to home' };
  const [breads, setBreads] = useState<IBreadcrumb[] | null>([unknown]);
  const lastParams = useRef('');
  const pageLinks: { [key: string]: IBreadcrumb } = dictionary;

  useEffect(() => {
    const pages = location.pathname.slice(1).split('/');

    if (location.pathname === '/' || !pages || pages.length <= 1) {
      setBreads(null);
    }
    if (pages && pages.length >= 2) {
      const payload: IBreadcrumb[] = [];

      pages.forEach((page, index) => {
        if (pageLinks[page]) {
          if (pageLinks[page]?.withParams) {
            lastParams.current = location.search;
          }
          if (pages[index - 1]) {
            payload.push({
              ...pageLinks[page],
              to: `${pageLinks[pages[index - 1]].to}${pageLinks[page].to}${
                pageLinks[page]?.withParams ? lastParams.current : ''
              }`,
            });
          } else {
            payload.push(pageLinks[page]);
          }
          lastParams.current = '';
        }
      });

      setBreads(payload);
    }
  }, [location, lastParams]);

  if (Array.isArray(breads) && breads?.length > 0) {
    return (
      <div className="mb-4">
        <Breadcrumbs
          separator="›"
          className="rounded-[10px] border border-appDark300 font-normal md:py-4 md:px-6 md:!text-base py-3 px-5 !text-sm !text-white"
          aria-label="breadcrumb"
        >
          {breads.map((b, i) =>
            i === breads.length - 1 ? (
              <Typography key={i} className="!text-white md:!text-base !font-semibold !text-sm">
                {b.label}
              </Typography>
            ) : (
              <NavLink key={i} to={b.to}>
                {' '}
                {b.label}{' '}
              </NavLink>
            ),
          )}
        </Breadcrumbs>
      </div>
    );
  }
  return null;
};

export default NibBreadcrumbs;
